// extracted by mini-css-extract-plugin
module.exports = {"header":"ShipmentAgent_header__3Gxrj","title":"ShipmentAgent_title__3yYlv","small":"ShipmentAgent_small__aN5Oy","btnContainer":"ShipmentAgent_btnContainer__10xzw"};